import React from 'react';
import { withContent } from '../../hoc/withContext';
import { IContent } from '../../types';
import {
  KeepRewardTitle,
  ImageSectionContainer, KeepBlockContainer,
  KeepRewardDescription,
  KeepRewardTextContainer
} from './KeepRewardsBlockStyle';
import GiftsAnimation from './GiftsAnimation/GiftsAnimation';
import Fade from "react-reveal/Fade";

interface IKeepRewards {
  context?: IContent
}

const KeepRewardsBlock = ({ context }: IKeepRewards) => {
  return (
    <Fade center>
      <KeepBlockContainer>
          <KeepRewardTitle isMobileTitle={true}
                           dangerouslySetInnerHTML={{ __html: context.keepRewards.title }} />
        <ImageSectionContainer>
            <GiftsAnimation />
        </ImageSectionContainer>
        <KeepRewardTextContainer>
          <Fade left distance={"2%"}>
            <KeepRewardTitle  isMobileTitle={false}
                              dangerouslySetInnerHTML={{ __html: context.keepRewards.title }} />
           <KeepRewardDescription>{context.keepRewards.description}</KeepRewardDescription>
          </Fade>
        </KeepRewardTextContainer>
      </KeepBlockContainer>
    </Fade>
  );
};

export default withContent(KeepRewardsBlock);